import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectMedicalExpensesTugoStep = (state) => state.get('medicalExpensesTugoStep');

const makeSelectMedicalExpensesTugoStep = () => createSelector(
  selectMedicalExpensesTugoStep,
  (MedicalExpensesTugoStepState) => ({

    babysDateOfBirth: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'babysDateOfBirth']),
      ''
    ),
       diagnosticImaging: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'diagnosticImaging']),
      ''
    ),
    isClaimRelatedToSelfInflictedYes: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'isClaimRelatedToSelfInflictedYes']),
      ''
    ),
    isClaimRelatedToSelfInflictedNo: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'isClaimRelatedToSelfInflictedNo']),
      ''
    ),
    
    didYouContactUsPriorToYourHospitalization: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'didYouContactUsPriorToYourHospitalization']),
      ''
    ),

    isYourClaimRelatedToPsychiatricTreatment: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'isYourClaimRelatedToPsychiatricTreatment']),
      ''
    ),

    isYourClaimRelatedToHIV: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'isYourClaimRelatedToHIV']),
      ''
    ),
    isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt']),
      ''
    ),

    whatExpensesAreYouClaimingFor: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      ''
    ),

    infoOutpatientDoctorOrClinicVisitItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoOutpatientDoctorOrClinicVisitItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoOutpatientDoctorOrClinicVisitItems']).toJS(),
      ''
    ),
    infoOutpatientDoctorOrClinicVisitSelfInflictedInjuriesAndAttemptedSuicideItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoOutpatientDoctorOrClinicVisitSelfInflictedInjuriesAndAttemptedSuicideItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoOutpatientDoctorOrClinicVisitSelfInflictedInjuriesAndAttemptedSuicideItems']).toJS(),
      ''
    ),
    infoHospitalChargesRelatedToPsychiatricTreatmentItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoHospitalChargesRelatedToPsychiatricTreatmentItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoHospitalChargesRelatedToPsychiatricTreatmentItems']).toJS(),
      ''
    ),
    infoHospitalChargesRelatedToHIVItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoHospitalChargesRelatedToHIVItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoHospitalChargesRelatedToHIVItems']).toJS(),
      ''
    ),
    infoHospitalizationChargesItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoHospitalizationChargesItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoHospitalizationChargesItems']).toJS(),
      ''
    ),
    infoInPatientHospitalExpensesSelfInflictedInjuriesAndAttemptedSuicideItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoInPatientHospitalExpensesSelfInflictedInjuriesAndAttemptedSuicideItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoInPatientHospitalExpensesSelfInflictedInjuriesAndAttemptedSuicideItems']).toJS(),
      ''
    ),
    infoBloodPlasmaItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoBloodPlasmaItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoBloodPlasmaItems']).toJS(),
      ''
    ),
    infoAnaesthesiologyItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoAnaesthesiologyItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoAnaesthesiologyItems']).toJS(),
      ''
    ),
    infoDentalSurgeryItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoDentalSurgeryItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoDentalSurgeryItems']).toJS(),
      ''
    ),
    infoWellBabyCareItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoWellBabyCareItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoWellBabyCareItems']).toJS(),
      ''
    ),
    infoAnnualHealthExamItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoAnnualHealthExamItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoAnnualHealthExamItems']).toJS(),
      ''
    ),
    infoVaccinationExpensesItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoVaccinationExpensesItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoVaccinationExpensesItems']).toJS(),
      ''
    ),
    infoCleftLipAndPalateAssistanceItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoCleftLipAndPalateAssistanceItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoCleftLipAndPalateAssistanceItems']).toJS(),
      ''
    ),
    infoMaternityExpenseItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoMaternityExpenseItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoMaternityExpenseItems']).toJS(),
      ''
    ),
    infoOncologyItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infoOncologyItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infoOncologyItems']).toJS(),
      ''
    ),
    infodDiagnosticNonMRIItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infodDiagnosticNonMRIItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infodDiagnosticNonMRIItems']).toJS(),
      ''
    ),
    infodDiagnosticMRIItems: mapWithDefault(
      MedicalExpensesTugoStepState,
      () => MedicalExpensesTugoStepState.getIn(['form', 'infodDiagnosticMRIItems']) && MedicalExpensesTugoStepState.getIn(['form', 'infodDiagnosticMRIItems']).toJS(),
      ''
    ),
  })
);

const makeSelectMedicalExpensesTugoStepErrors = () =>
  createSelector(selectMedicalExpensesTugoStep, (state) => state.get('errors'));

export {
  makeSelectMedicalExpensesTugoStep,
  makeSelectMedicalExpensesTugoStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.MedicalExpenses/selectors.js